import attack from "./roblox.mp3"
import battletheme from "./ost/battletheme.mp3"

const sounds = {attack,
    ost:{battletheme}
}

export {sounds}